var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSquareStartBracket = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5.799,
    height: 14,
    viewBox: "0 0 5.799 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.623.377A1.282,1.282,0,0,0,12.713,0H9.488a1.287,1.287,0,1,0,0,2.573h1.939v8.853H9.488a1.287,1.287,0,0,0,0,2.574h3.225A1.287,1.287,0,0,0,14,12.713V1.287A1.282,1.282,0,0,0,13.623.377Z",
    transform: "translate(14 14) rotate(180)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSquareStartBracket);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1Ljc5OSIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDUuNzk5IDE0Ij48ZGVmcz48c3R5bGU+LmF7ZmlsbDojZmZmO308L3N0eWxlPjwvZGVmcz48cGF0aCBjbGFzcz0iYSIgZD0iTTEzLjYyMy4zNzdBMS4yODIsMS4yODIsMCwwLDAsMTIuNzEzLDBIOS40ODhhMS4yODcsMS4yODcsMCwxLDAsMCwyLjU3M2gxLjkzOXY4Ljg1M0g5LjQ4OGExLjI4NywxLjI4NywwLDAsMCwwLDIuNTc0aDMuMjI1QTEuMjg3LDEuMjg3LDAsMCwwLDE0LDEyLjcxM1YxLjI4N0ExLjI4MiwxLjI4MiwwLDAsMCwxMy42MjMuMzc3WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTQgMTQpIHJvdGF0ZSgxODApIi8+PC9zdmc+";